<div class="progress-dialog">
  <div class="progress limit-slider">
    <ngx-slider #slider [(value)]="model.progress" [options]="options" [manualRefresh]="manualRefresh"></ngx-slider>
  </div>
  <div class="dialog-actions">
    <div class="dialog-actions-column">
      <button color="warn" mat-flat-button class="cancel" (click)="cancel()">
        {{ 'components.quantityDialog.cancel' | translate }}
      </button>
    </div>
    <div class="dialog-actions-column dialog-actions-column-right">
      <button color="primary" mat-flat-button class="confirm" (click)="confirm()">
        {{ 'components.quantityDialog.confirm' | translate }}
      </button>
    </div>
  </div>
</div>
